import axios from 'axios'
const { STD_API_URL } = process.env

const studentRequest = axios.create({
  baseURL: STD_API_URL, // API server url
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default studentRequest
